export const ACTIVE_LOYALTY_LENGTH_POSITION_ON_ICON = 10
